<small class="ogo-ngx-datatable-footer"> {{ 'TableTotal' | translate: { total: data?.totalElements ?? '' } }}</small>
<datatable-pager
  *ngIf="data"
  [pagerLeftArrowIcon]="pager.PREV"
  [pagerRightArrowIcon]="pager.NEXT"
  [pagerPreviousIcon]="pager.FIRST"
  [pagerNextIcon]="pager.LAST"
  [page]="page.number + 1"
  [size]="page.size"
  [count]="data.totalElements"
  (change)="changePage.emit($event.page - 1)"
/>
